import { useQuery } from '@apollo/client';
import { gql } from '../graphql/generated/gql';

const HAS_PASSWORD_QUERY = gql(/** @complexity 1 */ `
  query orgOnboardingPasswordSet {
    currentUser {
      hasPassword
    }
  }
`);

const useIsPasswordSet = () => {
  const response = useQuery(HAS_PASSWORD_QUERY);

  return {
    ...response,
    data: !!response.data && response.data.currentUser.hasPassword,
  };
};

export default useIsPasswordSet;
